import { type Animation, type CssResponsiveVariables, type Curve, type Duration, type Transition } from './types';

export interface PacingCssResponsiveVariables {
    '--pacing-slow'?: Duration;
    '--pacing-fast'?: Duration;
    '--pacing-slide-indicator'?: Duration;
}
export interface EasingCssResponsiveVariables {
    '--easing-fast-to-slow'?: Curve;
}
export interface TransitionsCssResponsiveVariables {
    '--transition-primary-fast'?: Transition;
    '--transition-primary-slow'?: Transition;
}

export interface AnimationsCssResponsiveVariables {
    '--animation-infinite-spin'?: Animation;
}

export const transitionsCssResponsiveVariables: CssResponsiveVariables<
    PacingCssResponsiveVariables &
        EasingCssResponsiveVariables &
        TransitionsCssResponsiveVariables &
        AnimationsCssResponsiveVariables
> = {
    'mobile.sm': {
        '--pacing-slow': '1s',
        '--pacing-medium': '0.5s',
        '--pacing-fast': '0.25s',
        '--ease-out': 'cubic-bezier(0.35, 0, 0.15, 1)',
        '--transition-primary-fast': `var(--pacing-fast) var(--ease-out)`,
        '--transition-primary-medium': `var(--pacing-medium) var(--ease-out)`,
        '--transition-primary-slow': `var(--pacing-slow) var(--ease-out)`,
        '--spin': 'spin',
        '--linear-infinite': 'linear infinite',
        '--animation-infinite-spin': `var(--spin) var(--pacing-slow) var(--linear-infinite)`,
    },
    'mobile.md': {},
    'mobile.lg': {},
    'tablet.sm': {},
    'tablet.lg': {},
    'desktop.sm': {},
    'desktop.md': {},
    'desktop.lg': {},
};
